export class ResourceCategoryModel {
    id?: any;
    name!: String;
    createAt?: any;
    is_editable!: string
}